module.exports = ES6Promise;